<template>
    <button
        :type="type"
        :class="buttonStyleClasses"
        :enabled="enabled"
        class="
            inline-flex
            items-center
            px-4
            py-2
            rounded-md
            font-semibold
            text-xs
            shadow-sm
            transition
            ease-in-out
            duration-150
        "
        @click="handleClick"
    >
        <svg v-if="showLoadingIndicator" class="animate-spin h-5 w-5 mr-3" viewBox="0 0 512 512">
            <path
                fill="currentColor"
                d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z"
                class=""
            ></path>
        </svg>
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: "button",
        },
        enabled: {
            type: Boolean,
            default: true,
        },
        buttonStyle: {
            type: String,
            default: "normal",
        },
        showLoadingIndicator: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["button-click"],
    computed: {
        buttonStyleClasses() {
            if (this.enabled) {
                switch (this.buttonStyle) {
                    case "danger":
                        return "bg-red-600 text-gray-50 hover:bg-red-400 focus:outline-none focus:bg-red-800";

                    case "success":
                        return "bg-green-400 text-gray-50 hover:bg-green-500 focus:outline-none focus:bg-green-500";

                    case "normal":
                    default:
                        return "bg-lightblue-500 text-gray-50 hover:bg-lightblue-600 focus:outline-none focus:bg-lightblue-600";
                }
            }

            switch (this.buttonStyle) {
                case "danger":
                    return "bg-red-300 text-gray-50";

                case "success":
                    return "bg-green-200 text-gray-50";

                case "normal":
                default:
                    return "bg-lightblue-400 text-gray-50";
            }
        },
    },
    methods: {
        handleClick() {
            if (!this.enabled) return;

            this.$emit("button-click");
        },
    },
};
</script>
